export default __webpack_public_path__ + "static/media/star.55cc8ac9.svg";